module.exports = __webpack_public_path__ + "img/7.d38b8260.jpg";